import module from 'usuario/module.js'
import template from './template.html'

export class UsuarioEstatusComponent {
  data
  onChange
  constructor (UsuarioEstatusService) {
    this.UsuarioEstatusService = UsuarioEstatusService
  }

  cambiarEstatus () {

    if (this.procesando) return

    this.error = null
    this.procesando = true

    this.UsuarioEstatusService.post(this.data.id)
      .then((response) => {
        this.procesado = true
        this.data.activo = response.data
      })
      .catch((error) => (this.error = error.data))
      .finally(() => (this.procesando = false))
  }

  finalizar () {
    this.onChange()
  }
}

module.component('usuarioEstatus', {
  controller: UsuarioEstatusComponent,
  template,
  bindings: {
    data: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/usuario/components/estatus/component.js